<br>
<div style="display: flex;
    justify-content: space-evenly;">
  <div style="width: 1024px;">
    <div class="p-grid p-fluid">
      <div class="p-col-fixed">
        <label for="ddTipo">Tipo</label>
        <p-dropdown id="ddTipo"
          [(ngModel)]="tipo"
          [options]="tipos"></p-dropdown>
      </div>
      <div class="p-col-6 p-lg-2">
        <label for="ddServidorAtualBd">Servidor BD</label>
        <p-dropdown id="ddServidorAtualBd"
          [(ngModel)]="pasta"
          [options]="optionsPasta[tipo]"></p-dropdown>
      </div>
      <div class="p-col-fixed">
        <label for="ddAno">Ano</label>
        <p-dropdown id="ddAno"
          [(ngModel)]="ano"
          [options]="anos"></p-dropdown>
      </div>
      <div class="p-col-fixed">
        <label for="ddMes">Mês</label>
        <p-dropdown id="ddMes"
          [(ngModel)]="mes"
          [options]="meses"></p-dropdown>
      </div>
      <div class="p-col-fixed">
        <label for="ddDias">Dia</label>
        <p-dropdown id="ddDias"
          [(ngModel)]="dia"
          [options]="dias"></p-dropdown>
      </div>
      <div class="p-col-6 p-lg-3 p-col-align-end">
        <button pButton
          icon="pi pi-search"
          [disabled]="loading"
          label="Buscar dados..."
          (click)="buscar()"></button>
      </div>
    </div>
    <div class="p-grid p-fluid">
      <div class="p-col">
        <input pInputText
          type="text"
          (input)="tableArquivos.filterGlobal($event.target.value, 'contains')"
          placeholder="Digite para buscar..." />
      </div>
      <div class="p-col-12">
        <p-table [value]="arquivos"
          #tableArquivos
          selectionMode="single"
          [globalFilterFields]="['key']"
          [scrollable]="true"
          scrollHeight="calc(100svh - 200px)"
          styleClass="p-datatable-sm p-datatable-striped"
          [loading]="loading">
          <ng-template pTemplate="header">
            <tr>
              <th pSortableColumn="key">Nome</th>
              <th style="width: 150px"
                class="col-fixa"
                pSortableColumn="lastModified">Modificação</th>
              <th style="width: 120px; justify-content: flex-end;"
                pSortableColumn="size"
                class="col-fixa">Tamanho</th>
              <th style="width: 100px"
                class="col-fixa"></th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body"
            let-row>
            <tr>
              <td>{{ nomeArquivo(row.key) }}</td>
              <td style="width: 150px"
                class="col-fixa">{{ row.lastModified | date: 'dd/MM/yyy HH:mm:ss' }}</td>
              <td style="width: 120px; justify-content: flex-end;;"
                class="col-fixa">{{ formatBytes(row.size) }}</td>
              <td style="width: 100px"
                class="col-fixa">
                <button (click)="baixar(row)"
                  class="p-button-text"
                  pButton
                  icon="pi pi-download"
                  label="Baixar"></button>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>
</div>